const VERSION = '2.16.105';
const BASE_URI = `/scripts/libs/pdfjs/${VERSION}`;
export const WORKER = `${BASE_URI}/pdf.worker.min.js`;
export const JS = [`${BASE_URI}/pdf.min.js`, `${BASE_URI}/pdf_viewer.min.js`];
export const CSS = [`${BASE_URI}/pdf_viewer.min.css`];
